import { useI18n } from '../i18n'
import { LEGAL } from '../legal/content'

/** Public long-form legal pages (/privacy, /terms) — content in legal/content.ts. */
export function Legal({ doc }: { doc: 'privacy' | 'terms' }) {
  const { lang, t } = useI18n()
  const d = LEGAL[doc][lang] ?? LEGAL[doc].en

  return (
    <main className="mx-auto max-w-3xl px-5 py-12">
      <h1 className="text-3xl font-extrabold tracking-tight">{d.title}</h1>
      <p className="mt-1 text-sm text-brand-500 dark:text-brand-400">{t('legal.updated', { date: d.updated })}</p>

      <div className="mt-6 space-y-4">
        {d.intro.map((p, i) => (
          <p key={i} className="text-brand-700 dark:text-brand-200">{p}</p>
        ))}
      </div>

      {d.sections.map((s) => (
        <section key={s.h} className="mt-8">
          <h2 className="text-lg font-bold">{s.h}</h2>
          <div className="mt-2 space-y-2">
            {s.ps.map((p, i) => (
              <p key={i} className="text-sm leading-relaxed text-brand-700 dark:text-brand-200">{p}</p>
            ))}
          </div>
        </section>
      ))}
    </main>
  )
}
